import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import {build, compile} from '../../scripts/renderTemplate';
import select from '../filter/filter';
import isElem from '../../scripts/util/isElement';
import {forEach} from 'ramda';
import fixedFilter from './fixedFilter';
import {refreshFilterPosition} from './fixedFilter';
import $ from 'jquery';

const selectors = {
	templates: '.js-templates',
	json: '#templates-json',
	previewTmp: '#preview-tmp',
	content: '#content',
	preview: '.clients__preview',
	showMore: '.show-more'
};

const classes = {
	fade: 'clients__preview_fade',
	hide: 'hide'
};


const element = $(selectors.previewTmp).clone()[0];
const fade = elem => elem.classList.remove(classes.fade);
const fadeAll = forEach(fade);

const animate = () => {
	const previews = qsa(selectors.preview);
	setTimeout(() => {
		fadeAll(previews);
	}, 300);
};

const insert = (block, output) => {
	block.innerHTML = output.join(' ');
	animate();
	refreshFilterPosition();
};

const initScrollEvent = () => {
	$(window).on('scroll.client-scroll', function () {
		refreshFilterPosition();
	});
};


const getData = areas => {

	if (typeof areas === 'undefined') {
		areas = 'all';
	}

	const data = $(selectors.json).length ? JSON.parse($(selectors.json).html())[areas] : [];
	const container = qs(selectors.content);
	const template = compile(element);
	initScrollEvent();
	build(template, data, container, insert)();
};

const filter = areas => {
	$(window).scrollTop($('.js-filter-box').offset().top - $('.js-header').height() - 60);
	if (Array.isArray(areas)) {
		areas = areas[0];
	}
	getData(areas);
};

const setValues = data => {
	filter(data);
};

const render = () => {
	if (isElem(selectors.templates)) {
		getData();
		select(setValues);
		fixedFilter();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/templates/templates.js